module.exports = __webpack_public_path__ + "static/img/2.db2d041.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/introduce/2.png
// module id = b3Hl
// module chunks = 0